import { useEffect, useRef, useState } from 'react';
import styles from './style/Tips.module.scss';

/**
 * hover 提示氣泡。
 *
 * side / align 為選填的定位控制；兩者都不帶時維持原本「元件下方、translateX(-40%)」的
 * 行為，不影響既有呼叫端。放在 overflow: auto 容器（如彈窗 body）內時，預設的往左位移
 * 容易被裁切，此時用 side='top' align='start' 讓氣泡貼齊元件左緣、往上展開。
 *   side:  'bottom'（預設）｜'top'
 *   align: 未指定＝既有行為｜'start'（貼左緣）｜'center'｜'end'（貼右緣）
 * topDiff / leftDiff 在既有行為下分別是 px / %；指定 align 時 leftDiff 一律當 px 位移。
 */
const Tips = (props) => {
  const [displayTip, setDisplayTip] = useState(false);
  const [tipPosition, setTipPosition] = useState(0);
  const containerRef = useRef(null);
  const { topDiff = 0, leftDiff = 0, penetrate, maxWidth, side = 'bottom', align } = props;

  useEffect(() => {
    if (containerRef.current) {
      const dom = containerRef.current.getBoundingClientRect();
      setTipPosition(dom.height);
    }
  }, [containerRef]);

  // 往上展開用 bottom: 100% 貼齊元件上緣，不必量測氣泡自身高度
  const sideStyle =
    side === 'top'
      ? { top: 'auto', bottom: `calc(100% + ${topDiff}px)` }
      : { top: `${tipPosition + topDiff}px` };
  // .tips 本身是 left: 0；align 各分支覆寫水平定位
  const alignStyle =
    align === 'start'
      ? { left: 0, right: 'auto', transform: `translateX(${leftDiff}px)` }
      : align === 'center'
      ? { left: '50%', right: 'auto', transform: `translateX(calc(-50% + ${leftDiff}px))` }
      : align === 'end'
      ? { left: 'auto', right: 0, transform: `translateX(${leftDiff}px)` }
      : { transform: `translateX(${-40 + leftDiff}%)` };

  return (
    <div ref={containerRef} style={{ position: 'relative' }} onMouseEnter={() => setDisplayTip(true)} onMouseLeave={() => setDisplayTip(false)}>
      {props.children}
      {displayTip && (
        <div
          className={`${styles.tips} ${penetrate ? styles.penetrate : ''}`}
          style={{
            ...sideStyle,
            ...alignStyle,
            maxWidth: `${maxWidth}`,
          }}
        >
          {props.detail ? <div dangerouslySetInnerHTML={{ __html: props.detail }} /> : ''}
        </div>
      )}
    </div>
  );
};

export default Tips;
